import { useTranslation } from 'react-i18next';


const WhyChooseUs = () => {
    const { t } = useTranslation();
    return (
        <div >
            <why-choose-us >
                <div id="whyChooseUsRegion" className="o-cont-fullw">
                    <div className="py-4 mt-6 mb-6 text-center block-bglight text-xl-start py-sm-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="text-center h1">Por qué elegirnos</h2>
                                    <ul className="o-list-features o-list-features_rounded column-gap-0">
                                        {/* <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Cubiertos.svg" alt="Restaurante buffet con cocina en vivo" />
                                            </span>
                                            <span>Restaurante De Blanc para desayunos</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Cóctel.svg" alt="Bares" />
                                            </span>
                                            <span>Lobby Bar</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Olas.svg" alt="Piscina" />
                                            </span>
                                            <span>Terraza El Jardí con plunge pool de temporada y servicio de bar</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Sauna.svg" alt="" />
                                            </span>
                                            <span>Sauna</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Gimnasio.svg" alt="Gimnàs i sauna" />
                                            </span>
                                            <span>Gimnasio</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Maletin.svg" alt="Icono_Maletin" />
                                            </span>
                                            <span>3 salones de reuniones con luz natural</span>
                                        </li>*/}
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Parking.svg" alt="" />
                                            </span>
                                            <span>Parking público y parking privado ($, no vigilados y con espacios para bicicletas)</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_CargadorElectrico.svg" alt="Icono_CargadorElectrico" />
                                            </span>
                                            <span>Punto de recarga para vehículos eléctricos ($)</span>
                                        </li>
                                        <li className="w-100 o-col-xs-mw2">
                                            <span className="round">
                                                <img src="https://pro-static.h10hotels.com/gallery/Icono_Wifi.svg" alt="Wi-Fi gratuito" />
                                            </span>
                                            <span>Wi-Fi gratuito</span>
                                        </li>

                                    </ul>
                                    {/* <div id="ubication-section" className="d-flex justify-content-center d-none">
                                        <button data-features-toggle="" type="button" className="mx-auto btn btn-secondary"> VER TODOS LOS SERVICIOS </button>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </why-choose-us>

        </div>
    );
};

export default WhyChooseUs;
